var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "max-w-sm mx-auto px-6" }, [
    _c("div", { staticClass: "flex items-center justify-center h-64" }, [
      _c("div", { staticClass: "text-center" }, [
        _vm._m(0),
        _c("br"),
        _vm._v(" "),
        _c("span", {
          staticClass: "text-sm text-grey-darker mt-4",
          domProps: { textContent: _vm._s(_vm.$t("Loading")) }
        })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon text-5xl text-grey" }, [
      _c("i", { staticClass: "mdi mdi-loading mdi-spin" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa5a0b6a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa5a0b6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Patient/LoadingBlock.vue
// module id = 790
// module chunks = 1